var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyNotesDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20938 15.75C1.84479 15.75 1.5349 15.6224 1.27969 15.3672C1.02448 15.112 0.896875 14.8021 0.896875 14.4375V1.96875H0V0.65625H4.1125V0H9.8875V0.65625H14V1.96875H13.1031V14.4375C13.1031 14.7875 12.9719 15.0937 12.7094 15.3562C12.4469 15.6187 12.1406 15.75 11.7906 15.75H2.20938ZM11.7906 1.96875H2.20938V14.4375H11.7906V1.96875ZM4.52813 12.5563H5.84063V3.82812H4.52813V12.5563ZM8.15938 12.5563H9.47188V3.82812H8.15938V12.5563ZM2.20938 1.96875V14.4375V1.96875Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNotesDelete);
export default __webpack_public_path__ + "static/media/myNotesDelete.7860e2a4987f1789c7b4b51ebe489348.svg";
export { ForwardRef as ReactComponent };